import { NgModule } from '@angular/core';
import { SetBackgroundImageDirective } from './add-background-image.directive';
import { CalculateFromFullHeightDirective } from './calc-from-full-height';
import { ClickOutsideDirective } from './click-outside.directive';
import { ClickableChipDirective } from './clickable-chip';
import { CustomBackgroundClassDirective } from './custom-background-class.directive';
import { DefaultImageOnErrorDirective } from './default-image-on-error';
import { LangCssClassDirective } from './lang-css-class.directive';
import { LetDirective } from './let.directive';
import { TextCutDirective } from './text-cut/text-cut.directive';

const directives = [
  TextCutDirective,
  LetDirective,
  ClickOutsideDirective,
  SetBackgroundImageDirective,
  CalculateFromFullHeightDirective,
  ClickableChipDirective,
  DefaultImageOnErrorDirective,
  LangCssClassDirective,
  CustomBackgroundClassDirective,
];

@NgModule({
  declarations: directives,
  exports: directives,
})
export class DirectivesModule {}
